import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { FileText, Eye, Download } from 'lucide-react';
import { STATUS_COLORS } from './declarationDommageShared';

export const DeclarationSuiviList = ({ mesDeclarations, viewDeclarationDetails, downloadPDF }) => {
  return (
    <>
              {mesDeclarations.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                  <FileText className="h-12 w-12 mx-auto mb-4 opacity-50" />
                  <p>Aucune déclaration de dommage</p>
                  <p className="text-sm">Vos déclarations apparaîtront ici</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {mesDeclarations.map((declaration) => (
                    <Card 
                      key={declaration.reference} 
                      className="cursor-pointer hover:shadow-md transition-shadow"
                      data-testid={`declaration-card-${declaration.reference}`}
                    >
                      <CardContent className="p-4">
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center gap-2 mb-2">
                              <span className="font-mono font-bold text-[#002d5b]">
                                {declaration.reference}
                              </span>
                              <Badge className={`${STATUS_COLORS[declaration.status]} text-white`}>
                                {declaration.status_label}
                              </Badge>
                              {declaration.dommage?.urgence && (
                                <Badge variant="destructive">URGENT</Badge>
                              )}
                            </div>
                            
                            <p className="text-sm text-gray-600">
                              <strong>Type :</strong> {declaration.dommage?.type_dommage_label}
                            </p>
                            <p className="text-sm text-gray-600">
                              <strong>Souscription :</strong> {declaration.subscription_reference}
                            </p>
                            <p className="text-sm text-gray-600">
                              <strong>Déclaré le :</strong>{' '}
                              {new Date(declaration.created_at).toLocaleDateString('fr-FR')}
                            </p>
                          </div>
                          
                          <div className="flex gap-2">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => viewDeclarationDetails(declaration.reference)}
                            >
                              <Eye className="h-4 w-4" />
                            </Button>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => downloadPDF(declaration.reference)}
                            >
                              <Download className="h-4 w-4" />
                            </Button>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>
              )}
    </>
  );
};
